import React, { useEffect, useState } from "react";
import { FiArrowUp } from "react-icons/fi";

export default function ScrollToTopButton() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 400);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

    return (
        <button
            type="button"
            onClick={scrollTop}
            aria-label="Scroll to top"
            className={`fixed bottom-6 end-6 z-50 w-11 h-11 rounded-full bg-navy-900 text-gold-400 shadow-card flex items-center justify-center hover:bg-navy-800 transition-all duration-300 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
            }`}
        >
            <FiArrowUp />
        </button>
    );
}
